<template>
  <div class="od-progress-bar">
    <od-progress-node :nodeType="1"/>
    <img class="order_status_divider" src="~@/assets/image/order_status_divider.png" />
    <od-progress-node :nodeType="2" :selectable="progressStatus >= 2"/>
    <img class="order_status_divider" src="~@/assets/image/order_status_divider.png" />
    <od-progress-node :nodeType="3" :selectable="progressStatus >= 3"/>
    <img class="order_status_divider" src="~@/assets/image/order_status_divider.png" />
    <od-progress-node :nodeType="4" :selectable="progressStatus >= 4"/>
  </div>
</template>

<script>
import OdProgressNode from '@/components/od-progress-node'
export default {
  name: 'od-status-progress',
  props: {
    progressStatus: {
      type: Number,
      default: 1
    }
  },
  components: {
    OdProgressNode
  }
}
</script>

<style lang="stylus" scoped>
.od-progress-bar
    display flex
    flex-direction row
    justify-content flex-end
    align-items center
    flex-grow 1
    width 200px
    height auto
    .od-node
      display flex
      flex-direction column
      align-items center
      justify-content center
      img
        margin-bottom 12px
        width 25px
        height 25px
      span
        color #31A826
        font-size 16px
    .order_status_divider
      padding-bottom 30px
</style>
